<template>
  <div>
    <div class="body" @touchstart="begin" :style="{top: top}" @touchmove="move" @touchend="over">
      <Card v-for="(item, index) in list.slice(0, showIndex)" :key="index" :data="item" :videoShowArr="videoShowArr" @send="showImg"></Card>
      <div v-if='list.length === 0' class="empty">
        <img class='empty-img' src="~assets/images/empty.png" alt="">
        <p>期待第一名中奖用户</p>
      </div>
      <div v-else :style="{fontSize: '0.138rem', lineHeight: '0.318rem',textAlign:'center'}">{{showIndex >= list.length ? '我是有底线的哦' : '加载中...'}}</div>
    </div>
    <div class="imgList2" v-if="show">
      <div v-if="src.indexOf('mp4') !== -1">
          <video class="bigVideo" :poster="poster" controls :src="src"></video>
      </div>
      <img class="closeButton"  @click.stop="hide" src="~assets/images/card/closeButton.png" alt="">
    </div>
  </div>
</template>
<script>
import Card from 'components/thousandAward/Card';
export default {
  components: {
    Card
  },
  data() {
    return {
      list: [],
      top: 0,
      topNum: 0,
      src: '',
      poster: '',
      show: false,
      videoList: [],
      clientHeight: 0,
      timer: 0,
      showIndex: 4, // 展示个数
      videoShowArr: [], // 控制视屏显隐数组
      timeout: '', // 定时器
    }
  },
  created() {
    collect('event_web_act_awardList_show',{
      timeStamp: +new Date(),
        })
  },
  mounted() {
    this.getData();
    setTimeout(() => {
      this.videoList = [...document.querySelectorAll('.smallVideo')];
      // this.videoList[0].play();
    }, 1000);
    this.clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
  },
  methods: {
    hide() {
      this.show = false;
    },
    showImg(src) {
      this.src = src[0];
      this.poster = src[1];
      this.show = true;
      setTimeout(() => {
          let video = document.getElementsByClassName('bigVideo');
          video[0] ? video[0].play() : '';
      }, 10)
    },
   async getData() {
     let arr = [];
     try {
        let thousandInfo = await this.$http.get('/apiserv/luckday/bigprize/getEvaluationList');
        arr = this._sortByTime(this._catchResponse(thousandInfo));
     } catch (error) {
       console.log(error)
     }
     try {
        let sendGoldInfo = await this.$http.get('/apiserv/splitVault/bigprize/getEvaluationList');
        arr = this._sortByTime(arr.concat(this._catchResponse(sendGoldInfo)));
     } catch (error) {
       console.log(error)
     }
    this.list = arr;
    },

    _catchResponse(allData) {
      const { data } = allData;
      if (data.return_code === 200) {
        return data.data;
      } else {
        window.$createToast({ txt: data.return_msg || '服务器异常哦，亲', time: 1500, type: 'error' }).show()
      }
    },
    begin(e) {
      this.topNum = e.touches[0].clientY;
    },
    move(e) {
      this.top === 0 ? this.top = e.touches[0].clientY - this.topNum + 'px' : "";
    },
    over() {
      this.top = 0;
      this.handleVideoPlay()
      this.addVideo();
    },
    addVideo() {
      this.videoList = [...document.querySelectorAll('.smallVideo')];
      if(this.videoList[this.showIndex - 1]) {
        const { showIndex, list } = this;
        let lastRect = this.videoList[this.showIndex - 1].getBoundingClientRect();
        if (lastRect.top + lastRect.height < this.clientHeight) {
          this.showIndex = showIndex + 4 < list.length ? showIndex + 4 : list.length;
        }
      }
    },
    handleVideoPlay() {
      const clientHeight = this.clientHeight;
      let icon = document.getElementsByClassName("pauseIcon");
      let poster = document.getElementsByClassName("poster");
      this.videoList.forEach((video, index) => {
        const clientRect = video.getBoundingClientRect();
        if (clientRect.top > 0 && clientRect.top + clientRect.height < clientHeight) {
          try {
            video.play();
            icon[index].style.display = 'none';
            poster[index].style.display = 'none';
          } catch (error) {
            // console.log(error);
          }
        } else {
          try {
            video.pause();
            icon[index].style.display = 'block';
            poster[index].style.display = 'block';
          } catch (error) {
            // console.log(error);
          }
        }
      })
    },
    _sortByTime(arr){ 
        if(arr.length<=1){
            return arr;
        }
        var nowNober = arr.splice( Math.floor(arr.length/2), 1 );  //取得数组中间的值
        var leftArr = [];
        var reightArr = [];
        for(var i=0; i<arr.length; i++){
            if(+arr[i].operationTime.slice(0, 10).split('-').join('') >= nowNober[0].operationTime.slice(0, 10).split('-').join('')){
                leftArr.push(arr[i]);                              //把比中间值小的放一个数组
            }else{
                reightArr.push(arr[i]);                            //把比中间值大的放另一个数组
            }
        }
        return this._sortByTime(leftArr).concat(nowNober, this._sortByTime(reightArr))  //在对小数组 、 大数组 继续回调上面的分组方法，最后当数组长度只有一的时候，不再往下执行，把返回的单个数组层层拼装新数组，即最后返回的排序好的数组
    }
  }
}
</script>
<style lang="less" scoped>
  .goBack{
      position: fixed;
      top: 0;
      height:1.33rem;
      width: 100%;
      line-height: 1.33rem;
      font-size: .5rem;
      font-family:PingFangSC-Medium;
      font-weight:600;
      color:rgba(51,51,51,1);
      text-align: center;
      z-index: 100;
      background-color: #fff;
  }
  .goBackIcon {
      position:absolute;
      top: 50%;
      margin-top: -0.33rem;
      left:.5rem;
      width: 0.67rem;
      height: 0.67rem;
      background-image: url("~assets/images/surpriseBMW/goBack.png");
      background-repeat: no-repeat;
  }
  .body {
      height: 100vh;
      overflow: auto;
      transition: top 0.2s linear;
      position: relative;
      color: #2c3e50;
  }
  .imgList2 {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(20, 20, 20, 0.7);
    color: #2c3e50;
    img {
      width: 100vw;
    }
    video {
      width: 100vw;
      height: 100vh;
    }
    .imgList2-img {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 90vw;
      }
    }
    .closeButton {
      position: absolute;
      width: 0.225rem;
      height: 0.225rem;
      right: 0.112rem;
      top: 0.112rem;
    }
  }
  .empty {
    color:rgba(147,147,153,1);
    font-family: PingFangSC-Regular;
    font-weight: 400;
    text-align: center;
    p {
      font-size: 0.1875rem;
    }
    .empty-img {
      width: 320px;
      height: 240px;
      margin: 25vh auto 0;
    }
  }
</style>


